<template>
  <div class="space">
    <div class="tab-list">
      <div class="mid">
        <span>个人空间</span>
      </div>
    </div>
    <div class="content">
      <div class="seaech-tab">
        <div class="tab-list">
          <div class="mid"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>


<style lang="less" scoped>
.space {
  .tab-list {
    background-color: #fff;
    padding: 20px 0px;
    border-bottom: 2px solid #eee;
    span {
      font-size: 17px;
      padding: 6px 8px;
      border-radius: 8px;
      margin-left: 100px;
      color: @color;
    }
  }
  .content {
    background-color: #fff;
    margin-top: 15px;
    padding: 10px 0px;
    .seaech-tab {
      .tab-list {
        padding: 13px 0px;
        border-bottom: 3px solid #eee;
        span {
          font-size: 14.5px;
          cursor: pointer;
          padding: 6px 8px;
          border-radius: 8px;
          margin: 0px 5%;
          color: rgb(54, 53, 53);
        }
        span:hover {
          color: @color;
          //background-color: @hover-bg;
        }
        .active {
          color: @color;
          //background-color: @hover-bg;
        }
      }
    }
    .space-table {
      padding-bottom: 30px;
      padding: 0px 15px;
      margin-top: 20px;
    }
  }
}
</style>
